import React, { useEffect } from "react";
import { connect } from "react-redux";
import authActions from "../../redux/auth/action";
import { getSessionLoginAt, recordSessionLogin } from "../sessionDuration";

const InactivityLogout = ({ logoutUser, isAuthenticated }) => {
  // 120 minutes
  const SESSION_TIMEOUT = 120 * 60 * 1000;
  let logoutTimer;

  const resetTimer = () => {
    clearTimeout(logoutTimer);
    startTimer();
  };

  const startTimer = () => {
    logoutTimer = setTimeout(() => {
      logoutUser();
    }, SESSION_TIMEOUT);
  };

  useEffect(() => {
    // Persisted sessions: ensure login clock exists after refresh.
    if (isAuthenticated && !getSessionLoginAt()) {
      recordSessionLogin({ force: true });
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      clearTimeout(logoutTimer);
      return undefined;
    }

    startTimer();

    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);

    return () => {
      clearTimeout(logoutTimer);
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
    };
  }, [isAuthenticated]);

  return null;
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth?.isAuthenticated,
});

const mapDispatchToProps = (dispatch) => {
  return {
    logoutUser: () => {
      dispatch(authActions.logoutUser());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InactivityLogout);
